import React, { useState, useEffect, Suspense } from 'react';
const LazyFeedbackButton = () => {
  const [shouldLoad, setShouldLoad] = useState(false);
  useEffect(() => {
   const handleScroll = () => {
      if (window.scrollY > 100) {
        window.removeEventListener('scroll', handleScroll);
        setTimeout(() => setShouldLoad(true), 2000);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    if (shouldLoad) {
      const timeout = setTimeout(() => {
        const hasSubmitted = localStorage.getItem('feedbackSubmitted') === 'true';
        if (hasSubmitted) return;
        let visitCount = parseInt(localStorage.getItem('feedbackVisitCount') || '0', 10);
        visitCount += 1;
        localStorage.setItem('feedbackVisitCount', visitCount.toString());
        if ((visitCount - 1) % 3 === 0) {
          document.querySelector('#auto-feedback-btn')?.click();
        }
      }, 60000);
      return () => clearTimeout(timeout);
    }
  }, [shouldLoad]);
  const FeedbackButton = React.lazy(() => import('./FeedbackButton'));
  return shouldLoad ? (
    <Suspense fallback={null}>
      <FeedbackButton />
    </Suspense>
  ) : null;
};
export default LazyFeedbackButton;